/**
 * RK Gift Card Section JavaScript (Simplified for Action Vouchers)
 * Handles all interactive functionality for the gift card product page
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const wrapper = document.querySelector('.rk-gift-card-wrapper');
    if (!wrapper) return;

    // Initialize all components
    initQuantitySelector();
    initAccordion();
    initImageGallery();
    initFormSubmit();
  }

  /**
   * Quantity Selector Handler
   */
  function initQuantitySelector() {
    const decreaseBtn = document.querySelector('.rk-qty-decrease');
    const increaseBtn = document.querySelector('.rk-qty-increase');
    const qtyInput = document.querySelector('.rk-qty-input');

    if (!decreaseBtn || !increaseBtn || !qtyInput) return;

    decreaseBtn.addEventListener('click', () => {
      const currentValue = parseInt(qtyInput.value) || 1;
      if (currentValue > 1) {
        qtyInput.value = currentValue - 1;
        animateQuantityChange(qtyInput);
      }
    });

    increaseBtn.addEventListener('click', () => {
      const currentValue = parseInt(qtyInput.value) || 1;
      qtyInput.value = currentValue + 1;
      animateQuantityChange(qtyInput);
    });

    qtyInput.addEventListener('change', function() {
      const value = parseInt(this.value) || 1;
      if (value < 1) {
        this.value = 1;
      }
    });

    qtyInput.addEventListener('blur', function() {
      if (!this.value || this.value < 1) {
        this.value = 1;
      }
    });
  }

  /**
   * Accordion Handler
   */
  function initAccordion() {
    const accordionHeaders = document.querySelectorAll('.rk-accordion-header');

    accordionHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const item = this.parentElement;
        const content = item.querySelector('.rk-accordion-content');
        const isActive = item.classList.contains('active');

        // Close all accordions
        document.querySelectorAll('.rk-accordion-item').forEach(accordionItem => {
          accordionItem.classList.remove('active');
          const accordionContent = accordionItem.querySelector('.rk-accordion-content');
          if (accordionContent) {
            accordionContent.style.maxHeight = null;
          }
        });

        // Toggle current accordion
        if (!isActive) {
          item.classList.add('active');
          if (content) {
            content.style.maxHeight = content.scrollHeight + 'px';
          }
        }
      });
    });
  }

  /**
   * Image Gallery Handler
   */
  function initImageGallery() {
    const thumbnails = document.querySelectorAll('.rk-thumbnail');
    const mainImage = document.querySelector('.rk-product-image');

    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const img = this.querySelector('img');
        if (img) {
          // Fade out
          mainImage.style.opacity = '0';
          
          setTimeout(() => {
            // Change image source (replace 150x with 800x for full size)
            const newSrc = img.src.replace('_150x', '_800x');
            mainImage.src = newSrc;
            mainImage.alt = img.alt;
            
            // Fade in
            mainImage.style.opacity = '1';
          }, 200);

          // Update active thumbnail
          thumbnails.forEach(t => t.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });
  }

  /**
   * Form Submit Handler
   */
  function initFormSubmit() {
    const form = document.querySelector('#rk-gift-card-form');
    const submitBtn = document.querySelector('.rk-add-to-cart-btn');

    if (!form || !submitBtn) return;

    form.addEventListener('submit', function(e) {
      // Add loading state
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;

      // Get form data
      const formData = new FormData(form);
      
      // AJAX submission
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Success feedback
        showSuccessMessage();
        
        // Update cart count if available
        updateCartCount();
        
        // Remove loading state
        setTimeout(() => {
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
        }, 1000);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        
        // Remove loading state
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
        
        // Show error message
        showErrorMessage();
      });

      // Prevent default form submission to stay on page
      e.preventDefault();
    });
  }

  /**
   * Helper Functions
   */

  function animateQuantityChange(input) {
    input.style.transform = 'scale(1.1)';
    setTimeout(() => {
      input.style.transform = '';
    }, 150);
  }

  function showSuccessMessage() {
    // Create success notification
    const notification = document.createElement('div');
    notification.className = 'rk-notification rk-notification-success';
    notification.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
      <span>Erfolgreich zum Warenkorb hinzugefügt!</span>
    `;
    
    document.body.appendChild(notification);
    
    // Add styles if not already present
    if (!document.querySelector('#rk-notification-styles')) {
      const styles = document.createElement('style');
      styles.id = 'rk-notification-styles';
      styles.textContent = `
        .rk-notification {
          position: fixed;
          top: 20px;
          right: 20px;
          background: white;
          padding: 16px 24px;
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 600;
          z-index: 9999;
          animation: slideInRight 0.3s ease;
        }
        .rk-notification-success {
          border-left: 4px solid #27ae60;
          color: #27ae60;
        }
        .rk-notification-error {
          border-left: 4px solid #e74c3c;
          color: #e74c3c;
        }
        @keyframes slideInRight {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        @keyframes slideOutRight {
          from {
            transform: translateX(0);
            opacity: 1;
          }
          to {
            transform: translateX(400px);
            opacity: 0;
          }
        }
      `;
      document.head.appendChild(styles);
    }
    
    // Remove notification after 3 seconds
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }

  function showErrorMessage() {
    const notification = document.createElement('div');
    notification.className = 'rk-notification rk-notification-error';
    notification.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <line x1="15" y1="9" x2="9" y2="15"/>
        <line x1="9" y1="9" x2="15" y2="15"/>
      </svg>
      <span>Fehler beim Hinzufügen zum Warenkorb</span>
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update cart count in header if element exists
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cart.item_count;
        });
        
        // Trigger custom event for other scripts
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart }
        }));
      })
      .catch(error => {
        console.error('Error updating cart count:', error);
      });
  }

  /**
   * Smooth scroll for anchor links
   */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const target = document.querySelector(href);
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });

  /**
   * Lazy loading optimization for images
   */
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          observer.unobserve(img);
        }
      });
    });

    document.querySelectorAll('img[data-src]').forEach(img => {
      imageObserver.observe(img);
    });
  }

})();